import { Injectable } from '@angular/core';
import { CoralogixRum } from '@coralogix/browser';
import { environment } from '@environment';

interface CoralogixAppContext {
	application: string;
	version: string;
}

@Injectable({
	providedIn: 'root',
})
export class CoralogixService {
	init(): void {
		CoralogixRum.init({
			application: 'angular-host',
			environment: environment.production ? 'production' : 'development',
			public_key: environment.coralogixPublicKey,
			coralogixDomain: 'EU2',
			version: '1.0.0',
		});
	}
	updateAppContext(context: CoralogixAppContext): void {
		CoralogixRum.setApplicationContext(context);
	}
}
